export default __webpack_public_path__ + "static/media/Social Links.9e5c8c85.svg";